import { IOrderBillFile } from './orderBillFile.model.interface';

export class OrderBillFile implements IOrderBillFile {
  readonly docId: string;
  readonly docName: string;
  readonly docType: string;
  readonly creationDate: Date;
  readonly metadata: string;

  constructor(data: IOrderBillFile) {
    this.docId = data.docId;
    this.docName = data.docName;
    this.docType = data.docType;
    this.creationDate = data.creationDate;
    this.metadata = data.metadata;
  }
}
